
import http from './http'

export default class StopwordApi {
    // 添加检测日志
    static stopwordLogAdd(params) {
        return http.httpPost('stopwordLog/add', params);
    }
    static stopwordLogGetCount(params) {
        return http.httpPost('stopwordLog/getCount', params);
    }
}



// WEBPACK FOOTER //
// ./app/api/stopword.log.api.js